<template>
  <section id="login" class="mt-5">
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3 col-sm-12">
          <div class="form-wrap">
            <h1 class="text-center">Login</h1>
            <hr>
            <form
              @submit="login"
              role="form"
              action="javascript:;"
              method="post"
              id="login-form"
              autocomplete="off"
            >
              <div :class="{'form-group': true, 'has-danger': !!error}">
                <label for="usuario" class="form-control-label">Usuario:</label>
                <input
                  required
                  type="text"
                  name="username"
                  id="usuario"
                  :class="{'form-control':true, 'is-invalid':!!error}"
                  placeholder="Ex.: supervisor"
                >
              </div>
              <div :class="{'form-group': true, 'has-danger': !!error}">
                <label for="key">Senha:</label>
                <input
                  required
                  type="password"
                  name="password"
                  id="key"
                  :class="{'form-control':true, 'is-invalid':!!error}"
                  placeholder="****"
                >
                <div class="invalid-feedback">{{error}}</div>
              </div>
              <input
                type="submit"
                id="btn-login"
                class="btn btn-custom btn-lg btn-block"
                value="Logar"
              >
            </form>
            <hr>
          </div>
        </div>
        <!-- /.col-xs-12 -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>
</template>

<script>
import API, { setToken } from "../../utils/api";
let $api;
export default {
  data() {
    return { error: "" };
  },
  created() {
    $api = new API();
  },
  methods: {
    login() {
      $api
        .doLogin(new FormData(document.querySelector("#login-form")))
        .then(({ data }) => {
          if (data.token) {
            setToken(data.token);
            let route = this.$route.query.to || "/marshall";
            this.$router.push(route);
          }
        })
        .catch(e => (this.error = e.response.data.error));
    }
  }
};
</script>

<style>
</style>
